<form [formGroup]="searchForm">
    <div fxLayoutGap="10px">
        <static-dictionary-select-ctrl [caption]="'claims-center.audanetIntegration.searchAudanetTasksType'"
            [formControlName]="'searchType'" [staticDictionaryName]="'searchAudanetTasksType'"
            (valueChangeEvent)="searchAudanetTasksTypeChange($event)" [settings]="{fxFill:true}">
        </static-dictionary-select-ctrl>

        <text-input-ctrl *ngIf="searchType===3" [caption]="'claims-center.audanetIntegration.plateNumber'"
            [formControlName]="'plateNumber'" [settings]="{fxFill:true}"></text-input-ctrl>

        <text-input-ctrl *ngIf="searchType===2" [caption]="'claims-center.audanetIntegration.vin'"
            [formControlName]="'vin'" [settings]="{fxFill:true}"></text-input-ctrl>

        <text-input-ctrl *ngIf="searchType===1" [caption]="'claims-center.audanetIntegration.claimNumber'"
            [formControlName]="'claimNumber'" [settings]="{fxFill:true}"></text-input-ctrl>

        <div fxFill fxLayoutAlign="center center"><button kendoButton (click)="search()">{{'global.search' |
                translate}}</button></div>
    </div>
</form>

<div>
    <app-loading-panel [isLoading]="audanetSearchOngoing"></app-loading-panel>

    <div *ngIf="searchResult$|async;let searchResult">
       
        <div *ngIf="searchResult?.length === 0">
            <h2>{{'claims-center.audanetIntegration.noAssociatedTasks' | translate}}</h2>
        </div>

        <div *ngIf="!!searchResult.length">
            <div *ngFor="let task of searchResult" class="form-block">
                <div fxFill fxLayout="column">
                    <div fxLayoutAlign="start center" fxLayout="row">
                        <div fxFlex="90">
                            <h3> {{'claims-center.audanetIntegration.foundTaskInfo' | translate}} : {{task.claimNumber}}
                            </h3>
                        </div>
                        <div fxFlex="10" fxLayoutAlign="end center">
                            <button *ngIf="audanetOperationType !== 6" kendoButton look="outline" icon="search"
                                (click)="openForCostEstimationImport(task.taskId)">{{'claims-center.audanetIntegration.showAudanetalCalculationDetails'
                                | translate}}</button>

                                <button *ngIf="audanetOperationType === 6" kendoButton look="outline" icon="check"
                                (click)="selectTask(task)">{{'claims-center.audanetIntegration.selectThisTask'
                                | translate}}</button>
                        </div>
    
                    </div>
                    <div fxLayout="row" fxLayoutGap="10px">
                        <div fxLayout="column wrap">
                            <h3>{{'claims-center.audanetIntegration.brandModel' | translate}} : {{task.carBrand}} {{
                                task.carModel}}</h3>
                            <div>{{'claims-center.audanetIntegration.plateNumber' | translate}} :
                                <strong>{{task.plateNumber}}</strong></div>
                            <div>{{'claims-center.audanetIntegration.vin' | translate}} : <strong>{{task.vin}}</strong>
                            </div>
                            <div>{{'claims-center.audanetIntegration.status' | translate}} :
                                <strong>{{task.taskStatus}}</strong></div>
                            <div>{{'claims-center.audanetIntegration.creationDate' | translate}} :
                                <strong>{{task.creationDate | date:'yyyy-MM-dd HH:mm' }}</strong></div>
                            <div>{{'claims-center.audanetIntegration.lastEditedDateTime' | translate}} :
                                <strong>{{task.lastEditedDateTime | date:'yyyy-MM-dd HH:mm'}}</strong></div>
                        </div>
    
                    </div>
                </div>
    
            </div>
        </div>
    </div>
    
</div>